import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScreeningPartyService } from 'src/app/core/services/screening-parties/screening-party.service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-screening-party-invitation',
  templateUrl: './screening-party-invitation.component.html',
  styleUrls: ['./screening-party-invitation.component.css']
})
export class ScreeningPartyInvitationComponent implements OnInit {
  @Input() screeningPartyId: any;
  screeningParty: any;
  timezone:any;

  constructor(private route: ActivatedRoute, private screeningPartyService: ScreeningPartyService, private router: Router) {
  }

  ngOnInit(): void {
    console.log(this.screeningPartyId);
    this.screeningPartyService.fetchScreeningParty(this.screeningPartyId).subscribe(response => {
      console.log(response);
      this.screeningParty = response;
      var zone = moment.tz.guess();       
      this.timezone = moment.tz(zone).format("z");
    },
    (error) => {
      console.log(error);
    });

    this.screeningPartyService.postRsvp(this.screeningPartyId).subscribe(
      (res) => {
        console.log('rsvp');
        console.log(res);
      },

      (error) => {
        console.log(error);
      }
    );
  }

  navigateShowcase(event){
    console.log(event);
    let name = event.movieName.replace(/ /g, '-');
    if(event.partyType === 'SPOTLIGHT'){
      this.router.navigateByUrl(`/cinejoy/premiere/more-info/${event.cinejoyFeaturedMovie}/${name}`)
  
    }
    else{
    this.router.navigateByUrl(`/cinejoy/showcase/moviepage/${event.cinejoyFeaturedMovie}/${name}/2025`)
    }
  }
}
